var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGift = function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.75 1a3.68 3.68 0 0 0-3.667 3.667c0 .67.196 1.29.514 1.833h-4.18a.917.917 0 0 0-.917.917v3.666c0 .507.41.917.917.917h20.166c.507 0 .917-.41.917-.917V7.417a.917.917 0 0 0-.917-.917h-4.18a3.6 3.6 0 0 0 .514-1.833A3.68 3.68 0 0 0 15.25 1c-1.097 0-2.076.5-2.75 1.273C11.826 1.5 10.847 1 9.75 1m0 1.833a1.82 1.82 0 0 1 1.833 1.834V6.5H9.75a1.82 1.82 0 0 1-1.833-1.833A1.82 1.82 0 0 1 9.75 2.833m5.5 0a1.82 1.82 0 0 1 1.833 1.834A1.82 1.82 0 0 1 15.25 6.5h-1.833V4.667a1.82 1.82 0 0 1 1.833-1.834m-11.917 11v8.25c0 .507.41.917.917.917h7.333v-9.167H3.334m10.084 0V23h7.333c.506 0 .917-.41.917-.917v-8.25h-8.25"
  })));
};
export default SvgGift;